import { ProductToNewProposal } from "../interfaces/ProductsList";
import BaseApi from "./BaseApi";

const baseUrl = 'api/product/';

class ProductService {

    static post(request: any): Promise<number> {
        return BaseApi.post(`${baseUrl}`, request);
    }

    static put(request: any): Promise<number> {
        return BaseApi.put(`${baseUrl}`, request);
    }

    static patchActive(request: any): Promise<number> {
        return BaseApi.patch(`${baseUrl}active`, request);
    }

    static postPrice(file: any): Promise<number> {
        let bodyFormData = new FormData();
        bodyFormData.append('file', file);
        return BaseApi.post(`${baseUrl}price`, bodyFormData);
    }

    static postPromoSheet(file: any): Promise<number> {
        let bodyFormData = new FormData();
        bodyFormData.append('file', file);
        return BaseApi.post(`${baseUrl}import-excel-kitpromo`, bodyFormData);
    }

    static postWEGSheet(file: any): Promise<number> {
        let bodyFormData = new FormData();
        bodyFormData.append('file', file);
        return BaseApi.post(`${baseUrl}import-excel-weg`, bodyFormData);
    }

    static postCalculation(form: any): Promise<any> {
        return BaseApi.post(`${baseUrl}calculation`, form);
    }
    static postCategory(request: any): Promise<number> {
        return BaseApi.post(`${baseUrl}category`, request);
    }

    static getToEdit(id: number): Promise<any> {
        return BaseApi.get(`${baseUrl}${id}/edit`);
    }

    static getToList(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}list`);
    }

    static getListToNewProposal(): Promise<ProductToNewProposal[]> {
        return BaseApi.get(`${baseUrl}list/new-proposal`);
    }

    static getPriceHistory(id: number): Promise<any[]> {
        return BaseApi.get(`${baseUrl}${id}/price/history`);
    }

    static getPriceSpreadsheet(): Promise<any> {
        return BaseApi.get(`${baseUrl}price/spreadsheet/example`);
    }

    static async getCategory(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}category`);
    }

    static async getCategoryProductRegister(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}register/category`);
    }

    static async getType(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}type`);
    }

    static getToDetail(id: number): Promise<any> {
        return BaseApi.get(`${baseUrl}${id}/detail`);
    }

    static async getModule(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}module`);
    }
}

export default ProductService;